/**
 * Inventory API (/api/v1/inventory) — scoped to the user's warehouse.
 */

import { apiGet } from "./client";
import { InventoryListParams, InventoryListResponse } from "./types";

export function listInventory(
  params?: InventoryListParams
): Promise<InventoryListResponse> {
  return apiGet<InventoryListResponse>("/inventory", params);
}
